import * as actionTypes from "Redux/Actions/actionTypes";

const doAccountSearch = (searchCriteria, callback = () => {}) => ({
  type: actionTypes.ACCOUNT_SEARCH,
  data: searchCriteria,
  callback,
});

const doAccountCreate = (accountData, callback = () => {}) => ({
  type: actionTypes.ACCOUNT_CREATE,
  data: accountData,
  callback,
});

export { doAccountSearch, doAccountCreate };
